<template>
	<div>
		<div class="sf-widget-bookmark">
			<el-collapse v-model="activeName">
				<el-collapse-item v-for="(groupName, idx) in groupNames" :title="groupName" :key="idx" :name="idx">
					<ul>
						<li class="bookmark__item" v-for="item in bookmarkList[groupName]" :key="item.scrId" v-bind="item" @click="clickLink">
							{{ item.scrName }}
						</li>
					</ul>
				</el-collapse-item>
			</el-collapse>
		</div>
	</div>
</template>
<script>
import client from '@/api/client';
import { rootComputed } from '@/store/common/helpers';
import { BASE_URL } from '@/constants';

const api = {
	selectFavorites: ({ plantCd = 'HVS1' }) => client.get(`${BASE_URL}/menu/v1/plants/${plantCd}/favorites`).then(r => r.data)
};
export default {
	name: 'widget-bookmark',
	props: {
		properties: {
			type: Object,
			default: () => {}
		},
		plantCd: {
			type: String,
			default: 'HVS1'
		}
	},
	mounted() {
		this.refresh();
	},
	computed: {
		...rootComputed,
		groupNames() {
			return Object.keys(this.bookmarkList);
		},
		bookmarkList() {
			return _(this.widgetfavorites)
				.map(item => ({
					...item,
					scrName: this.getMessage_(item.msgKey),
					parentScrName: this.getMessage_(item.parentMsgKey)
				}))
				.groupBy('parentScrName')
				.value();
		}
	},

	methods: {
		async refresh() {
			let res = [];
			res = await api.selectFavorites({ plantCd: this.plantCd });
			this.widgetfavorites = res.body;

			// console.log('bookmark', this.favorites);
			return this.widgetfavorites;
		},
		clickLink(e) {
			const message = {
				message: 'moveScreen',
				scrType: e.target.getAttribute('scrType'),
				scrId: e.target.getAttribute('scrId'),
				queryString: {}
			};
			// console.log('postMessage', message);
			window.parent.postMessage(message, '*');
		}
	},
	data() {
		return {
			activeName: '1',
			//TODO: 온사이트 favorites 변수명 중복
			widgetfavorites: [],
			sampleData: {
				body: [
					{
						userId: 'WJKIM',
						scrId: 'S00001038',
						regDt: null,
						scrUrl: 'http://10.6.120.81:9003/MituHistory',
						scrName: 'MITU History',
						msgKey: 'SWCC000220',
						parentScrId: 'S00000109',
						parentScrName: 'Change History',
						parentMsgKey: 'SWCC000196',
						scrType: 'C'
					},
					{
						userId: 'WJKIM',
						scrId: 'S00001090',
						regDt: null,
						scrUrl: 'http://10.6.120.81:9000/Notification',
						scrName: 'Notifications',
						msgKey: 'SWCC000531',
						parentScrId: 'S00000125',
						parentScrName: 'Basic Setting',
						parentMsgKey: 'SWCC000211',
						scrType: 'C'
					},
					{
						userId: 'WJKIM',
						scrId: 'S00001086',
						regDt: null,
						scrUrl: 'http://10.6.120.81:9000/CommonCode',
						scrName: 'Common Code',
						msgKey: 'SWCC000174',
						parentScrId: 'S00000125',
						parentScrName: 'Basic Setting',
						parentMsgKey: 'SWCC000211',
						scrType: 'C'
					}
				]
			}
		};
	}
};
</script>

<style></style>
